import defaultConfig from '../config/default.json';

// let BASE_URL =
// "https://dblrr0skf6uxv.cloudfront.net/";
// 'https://d2kkj1xdo5oi00.cloudfront.net/';
//   process.env.REACT_APP_BASE_URL ||
//   'http://spi-mia-fargate-lb-159198850.eu-west-2.elb.amazonaws.com/';
let BASE_URL = process.env.REACT_APP_BASE_URL || '';
BASE_URL = BASE_URL + 'api/';
const USER_API_BASE_URL = defaultConfig['user_api']['base_url'];
const DASH_API_BASE_URL = defaultConfig['dashboard_api']['base_url'];
const REPORT_API_BASE_URL = defaultConfig['report_api']['base_url'];
const PREFERENCES_API_BASE_URL = defaultConfig['preferences_api']['base_url'];
const INSIGHTS_API_BASE_URL = defaultConfig['insights_api']['base_url'];
const ANALYSIS_API_BASE_URL = defaultConfig['analysis_api']['base_url'];
const IMPORT_API_BASE_URL = defaultConfig['import_analysis_api']['base_url'];
const IMPORT_API_POST_URL = defaultConfig['imported_campaigns_post']['base_url'];
const REPORTS_API_BASE_URL = defaultConfig['reports_api']['base_url'];
const ADMIN_API_BASE_URL = defaultConfig['admin_api']['base_url'];
const BLS_BASE_URL = defaultConfig['bls_api']['base_url'];

// const businessAccountIdRegex = /{businessAccountId}/;
// const adAccountIdRegex = /{adAccountId}/;
const reportIdRegex = /{reportId}/;
const advertiserNameRegex = /{advertiser}/;
const advIdRegex = /{advId}/;

function _getDashAPIUrl(endPointRelativePath) {
  const dashApiURL = DASH_API_BASE_URL + endPointRelativePath;
  return dashApiURL;
}

function _getUserAPIUrl(endPointRelativePath) {
  const userApiURL = USER_API_BASE_URL + endPointRelativePath;
  return userApiURL;
}

function _getReportAPIUrl(endPointRelativePath) {
  const reportApiURL = REPORT_API_BASE_URL + endPointRelativePath;
  return reportApiURL;
}

function _getPreferencesAPIUrl(endPointRelativePath) {
  const preferencesApiURL = PREFERENCES_API_BASE_URL + endPointRelativePath;
  return preferencesApiURL;
}
function _getInsightsAPIUrl(endPointRelativePath) {
  const InsightsApiURL = INSIGHTS_API_BASE_URL + endPointRelativePath;
  return InsightsApiURL;
}
function _getImportsAPIUrl(endPointRelativePath) {
  const ImportsApiURL = IMPORT_API_BASE_URL + endPointRelativePath;
  return ImportsApiURL;
}
function _getAnalysisAPIUrl(endPointRelativePath) {
  const analysisApiURL = ANALYSIS_API_BASE_URL + endPointRelativePath;
  return analysisApiURL;
}
function _getImportedCampaignsAPIUrl(endPointRelativePath) {
  const ImportsApiURL = IMPORT_API_POST_URL + endPointRelativePath;
  return ImportsApiURL;
}
function _getReportsAPIUrl(endPointRelativePath) {
  const reportsApiURL = REPORTS_API_BASE_URL + endPointRelativePath;
  return reportsApiURL;
}
function _getAdminAPIUrl(endPointRelativePath) {
  const reportsApiURL = ADMIN_API_BASE_URL + endPointRelativePath;
  return reportsApiURL;
}
function _getBlsAPIUrl(endPointRelativePath) {
  const reportsApiURL = BLS_BASE_URL + endPointRelativePath;
  return reportsApiURL;
}
function get(api, path) {
  const configProperty = defaultConfig[api][path];
  if (configProperty) {
    switch (api) {
      case 'user_api':
        return _getUserAPIUrl(configProperty);
      case 'dashboard_api':
        return _getDashAPIUrl(configProperty);
      case 'report_api':
        return _getReportAPIUrl(configProperty);
      case 'preferences_api':
        return _getPreferencesAPIUrl(configProperty);
      case 'insights_api':
        return _getInsightsAPIUrl(configProperty);
      case 'import_analysis_api':
        return _getImportsAPIUrl(configProperty);
      case 'analysis_api':
        return _getAnalysisAPIUrl(configProperty);
      case 'imported_campaigns_post':
        return _getImportedCampaignsAPIUrl(configProperty);
      case 'reports_api':
        return _getReportsAPIUrl(configProperty);
      case 'admin_api':
        return _getAdminAPIUrl(configProperty);
      case 'bls_api':
        return _getBlsAPIUrl(configProperty);
      case 'send_otp_url':
        return _getBlsAPIUrl(configProperty);
      case 'verify_otp_url':
        return _getBlsAPIUrl(configProperty);
      default:
        return configProperty;
    }
  } else return null;
}

function getBaseUrl() {
  return BASE_URL;
}

function formUrl(url, reportId, advId) {
  let formedUrl = url;

  if (reportId) {
    formedUrl = formedUrl.replace(reportIdRegex, reportId);
  }
  if (advId) {
    formedUrl = formedUrl.replace(advIdRegex, advId);
  }
  // if (businessAccountId) {
  //   formedUrl = formedUrl.replace(businessAccountIdRegex, businessAccountId);
  // }

  // if (adAccountId) {
  //   formedUrl = formedUrl.replace(adAccountIdRegex, adAccountId);
  // }

  return formedUrl;
}

function advertiserUrl(url, advertiser) {
  let formedUrl = url;
  if (advertiser) {
    formedUrl = formedUrl.replace(advertiserNameRegex, advertiser);
  }
  return formedUrl;
}

const config = { get, getBaseUrl, formUrl, advertiserUrl };

export default config;
